module.exports = __webpack_public_path__ + "assets/picture-stack-landscape.213d47d2.svg";